// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getServiceIntervalStatusesList} from '../../shared/repositories';

export const updateServiceIntervalStatuses = () =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return getServiceIntervalStatusesList()
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_STATUSES_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };




// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/action-creators/update-service-interval-statuses.js